import { createContext } from 'react';

export type GroupCreationCtx = {
  showGroupCreationErrorAlert: boolean;
  groupCreationError: string;
};

const GroupCreationDialogueContext = createContext<GroupCreationCtx>({
  showGroupCreationErrorAlert: false,
  groupCreationError: '',
});

export default GroupCreationDialogueContext;